export const getVariantImage = (
	url: string,
	tag: `{${string}}`,
	variant: "small" | "large"
): string => {
	return url?.replace(tag, variant).replace("{size}", variant);
};
